import { useEffect, useState } from "react";
import { dictionaryCRUD } from "../../../actions/dictionary";
import { TableShared } from "../../../shared";
import { DictionaryItemAdd } from "./add";
import { char } from "../../../utils";
import {
  Button,
  Dropdown,
  Space,
} from "antd";
import {
  MoreOutlined,
  EyeOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useNotification } from "../../../utils/notificationProvider";

export const DictionaryItemContent = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");

  const openNotification = useNotification


  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      dictionaryCRUD
        .loadDictionaryItem(
          postsPerPage,
          nextPage,
          value,
          sortType === "desc" ? "-" + sortColumn : sortColumn
        )
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Sorry...!
              <br />
              {error.message}
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage, sortColumn, sortType]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 150,
    },
    {
      key: "dictionary_item_code",
      title: "Dictionary Item Code",
      dataIndex: "dictionary_item_code",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "dictionary",
      title: "Dictionary",
      dataIndex: "dictionary",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "dictionary_item_name",
      title: "Dictionary Item Name",
      dataIndex: "dictionary_item_name",
      sortable: true,
      flexGrow: 1,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "Edit",
                key: "edit",
                icon: <EditOutlined />,
              },
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "1":
                  setOpen(true);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"middle"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    dictionary_item_code: dt.dictionary_item_code
      ? dt.dictionary_item_code
      : "N/A",
    dictionary: dt.dictionary
      ? char.toTitleCase(dt.dictionary.dictionary_name)
      : "N/A",
    dictionary_item_name: char.toTitleCase(dt.dictionary_item_name),
  }));

  const button = (
    <button
      className="btn btn-primary bg-gradient btn-border"
      onClick={() => setOpen(true)}
    >
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Dictionary
      Item
    </button>
  );

  return (
    <>
      <DictionaryItemAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Dictionary Items</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
